import { Accept } from 'react-dropzone';
export interface IDropZoneErrorMessages {
    'file-invalid-type': string;
    'file-too-large': string;
}

export enum DropZoneType {
    default = 'default',
    project = 'project',
}

//IN BYTES
export const PROPOSAL_ADDITIONAL_DOCS_FILE_SIZE_LIMIT = 104857600;
export const EXTENSION_REQIEST_FILE_SIZE_LIMIT = 5000000;
export const ADMIN_DOCUMENTS_FILE_SIZE_LIMIT = 15000000;
export const FINAL_PROJECT_FILE_SIZE_LIMIT = 104857600;
export const PROFILE_PICTURE_FILE_SIZE_LIMIT = 8000000;
export const LOGO_FILE_SIZE_LIMIT = 3000000;
export const ACADEMIC_DEGREE_PROOF_FILE_SIZE_LIMIT = 5000000;

export const acceptPdf: Accept = { 'application/pdf': ['.pdf'] };

export const acceptAllProjectFileTypes: Accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        '.docx',
    ],
    'text/csv': ['.csv'],
    'application/gzip': ['.gz'],
    'application/vnd.rar': ['.rar'],
    'application/vnd.ms-powerpoint': ['.ppt'],
    'application/vnd.ms-powerpoint.presentation.macroEnabled.12': ['.pptm'],
    'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        ['.pptx'],
    'image/svg+xml': ['.svg'],
    'text/plain': ['.txt'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx',
    ],
    'application/vnd.ms-excel': ['.xls'],
    'application/zip': ['.zip'],
    'application/x-7z-compressed': ['.7z'],
};

export const acceptExtensionRequestFileTypes: Accept = {
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        '.docx',
    ],
};

export const acceptGradingNotesFileTypes: Accept = {
    'image/png': ['.png'],
    'image/jpeg': ['.jpg', '.jpeg'],
    'application/pdf': ['.pdf'],
    'application/msword': ['.doc'],
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': [
        '.docx',
    ],
    'text/csv': ['.csv'],
    'text/plain': ['.txt'],
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
        '.xlsx',
    ],
};
